<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="tx">Whoever does not miss the Soviet Union has no heart. Whoever wants it back has no brain.</p>
<p class="right">Vladimir Putin</p>
<p class="tx">Beware: Some liars tell the truth!</p>
<p class="right">Ancient Arab proverb</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c7.vue?087f9728